export const RESPONSIVE_TABLET = 1024;

export const RESPONSIVE_BIG_MOBILE = 768;

export const RESPONSIVE_SMALL_MOBILE = 576;
